<p-dialog
  [header]="('acl.label' | translate) + ' ' + (selected?.name || '')"
  [(visible)]="modalVisible"
  >
  <div class="flex flex-column gap-large pt-3 small-buttons">
    <app-text-input [form]="form" id="name" [prefix]="prefix"></app-text-input>
    <app-multi-select-input
      [form]="form"
      id="children"
      label="acl.group.fields.children"
      [staticOptions]="store.data.allAvailableGroups$ | async"
      valueKey="id"
      labelKey="name"
      display="comma">
      <ng-template #selectedItems let-items>
        @if (items?.length) {
          @for (item of items; track item; let last = $last) {
            <div>
              {{ item.name }}@if (!last) {
              <span>,</span>
            }
          </div>
        }
      } @else {
        <div class="p-multiselect-label"></div>
      }
    </ng-template>
  </app-multi-select-input>

  <!--        <ng-container *ngIf="store.allResources$ | async as rules">-->
  <!--            <div class="grid-7col input-grid-gaps" style="justify-items: center;">-->
  <!--                <div class="justify-self-end">{{ 'acl.group.fields.resource' | translate }}</div>-->
  <!--                <ng-container *ngFor="let action of actions">-->
  <!--                    <div>{{ ('acl.group.action.' + action) | translate }}</div>-->
<!--                </ng-container>-->
<!--                <div>{{ 'acl.group.action.all' | translate }}</div>-->

<!--                <ng-container *ngFor="let rule of rules">-->
<!--                    <div class="justify-self-end">{{ ('acl.group.resource.' + rule.resource) | translate }}<span-->
<!--                        *ngIf="rule.resource === 'rule'" class="text-danger markSize">**</span></div>-->
<!--                    <ng-container *ngFor="let action of actions">-->
<!--                        <div class="checkMark">-->
<!--                            <p-checkbox class="checkMark_item"-->
<!--                                [formControl]="$any(form.controls.rules).controls[rule.resource + KEY_JOIN + action]"-->
<!--                                [binary]="true"></p-checkbox>-->
<!--                            <div *ngIf="selected?.inherited?.includes(rule.resource + KEY_JOIN + action)"-->
<!--                                class="checkMark_item text-danger markSize checkMark_item-times">*-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </ng-container>-->
<!--                    <app-button icon="pi-check" severity="secondary" [rounded]="true"-->
<!--                        (clickEvent)="selectAll(rule.resource)"></app-button>-->
<!--                </ng-container>-->
<!--            </div>-->
<!--        </ng-container>-->
</div>
<div class="flex justify-content-end">
  <div class="mt-3"><span class="text-danger markSize">*</span>{{ 'acl.inherited' | translate }}</div>
</div>
<div class="flex justify-content-end">
  <div class="mt-1"><span class="text-danger markSize">**</span>{{ 'acl.ruleWarning' | translate }}</div>
</div>

<ng-template pTemplate="footer">
  <app-action-buttons (primaryClickEvent)="submit()" (secondaryClickEvent)="showModal(false)">
    <app-delete-button [disabled]="!isAllowed['rule.delete']()"
    (clickEvent)="delete($event)"></app-delete-button>
  </app-action-buttons>
</ng-template>
</p-dialog>

@if (isAllowed['rule.read']()) {
  <p-card>
    @if (store.organizationGroups$ | async; as groups) {
      <div class="flex gap-small align-items-center small-buttons mb-2">
        <div class="textSubheader">{{ 'acl.labelMulti' | translate }}</div>
        @if (isAllowed['rule.create']()) {
          <app-button icon="pi-plus"
          (clickEvent)="select(null)"></app-button>
        }
      </div>
      @for (group of groups; track group) {
        <div class="flex flex-column gap-large">
          <div class="flex flex-column gap-x-small">
            @if (!isAllowed['rule.update']) {
              <div>{{ group.name }}</div>
            }
            @if (isAllowed['rule.update']) {
              <app-link-button [label]="group.name"
              (clickEvent)="select(group)"></app-link-button>
            }
            @if (group.children.length) {
              <div class="ml-5 mb-3 flex gap-small align-items-center">
                <div>{{ 'acl.group.fields.children' | translate }}:</div>
                @for (child of group.extending; track child; let last = $last) {
                  <div>{{ child.name }}@if (!last) {
                    <span>,</span>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  }
</p-card>
}
